import React from "react";
import styled from "styled-components";

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.primitiveTokens.spacing.spacing_sm};
  padding: ${({ theme }) => theme.primitiveTokens.spacing.spacing_md}
    ${({ theme }) => theme.primitiveTokens.spacing.spacing_lg};
  border-left: ${({ theme }) =>
    `${theme.resolve("border_3xl")} solid ${theme.resolve(
      "color_border_lighter"
    )}`};
  border-right: ${({ theme }) =>
    `${theme.resolve("border_md")} solid ${theme.resolve(
      "color_border_lighter"
    )}`};
  border-top: ${({ theme }) =>
    `${theme.resolve("border_md")} solid ${theme.resolve(
      "color_border_lighter"
    )}`};
  gap: ${({ theme }) => theme.resolve("spacing_xs")};
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  padding: ${({ theme }) => theme.primitiveTokens.spacing.spacing_xs};
  cursor: pointer;
  color: ${({ theme }) => theme.resolve("color_text_tertiary")};
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.resolve("color_text_primary")};
  }
`;

type TableInlineFiltersProps = {
  children: React.ReactNode;
  showClearAll: boolean;
  onClearAll: () => void;
  clearAllLabel?: string;
};

export function TableInlineFilters({
  children,
  showClearAll = false,
  onClearAll,
  clearAllLabel = "Clear Filters",
}: TableInlineFiltersProps) {
  return (
    <FiltersRow>
      {children}
      {showClearAll && onClearAll && (
        <ClearButton onClick={onClearAll}>{clearAllLabel}</ClearButton>
      )}
    </FiltersRow>
  );
}
